@if (initialized && dto) {
    <ei-structure-full
            [objectIdentifier]="objectIdentifier"
            [uiMode]="uiMode"
            [dto]="dto"
            [structureDto]="dto"
            (onNavigationItems)="handleNavigationItems($event)"
    ></ei-structure-full>
}
